import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";

export class PackageCustomFieldsTableRowComponent implements IController {

  field: any;
  onEdit: Function;
  onDelete: Function;


  constructor() {

  }

  $onInit() {

  }

  $onChanges(changes: IOnChangesObject) {

  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageCustomFieldsTableRow', {
    bindings: {
      field: '<',
      onEdit: '&',
      onDelete: '&',
    },
    template: require('./package-custom-fields-table-row.html').default,
    controller: PackageCustomFieldsTableRowComponent
  });
